module.exports = __webpack_public_path__ + "img/garantie-hospitalisation.fd6b2933.svg";